/**
 * Filter for Profile Name it the name is too long
 */
var filter = function () {
    return function (input) {
        var output = angular.isDefined(input) ? input : "";
        if (output.length > 45) {
            return output.substring(0, 45) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var CompanyNameFilter = {
    name: 'companyNameFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name.filter.js.map